import { Pipe, PipeTransform } from '@angular/core';
import { CostElement } from '../model/cost-element';

@Pipe({
  name: 'costFilter'
})
export class CostFilterPipe implements PipeTransform {

  transform(items: CostElement[], term: string): CostElement[] {
    if (!items) {
      return [];
    }
    if (!term) {
      return items;
    }

    term = term.toLowerCase();
    return items.filter(it => {
      return this.match(it.name, term)
        || this.match(it.measure_unit, term)
        || this.match(`${it.installation_cost}`, term)
        || this.match(`${it.cost}`, term);
    });
  }

  private match(value: string, term: string) {
    return value.toLowerCase().includes(term);
  }

}
